var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.472656 11.050781 L 14.605469 11.050781 L 14.605469 16.972656 L 9.472656 16.972656 Z M 9.472656 11.050781 "
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.003906 11.394531 L 9.917969 12.601562 C 9.839844 12.648438 9.792969 12.726562 9.792969 12.816406 L 9.792969 15.226562 C 9.792969 15.316406 9.839844 15.402344 9.917969 15.445312 L 12.003906 16.648438 C 12.085938 16.691406 12.179688 16.691406 12.257812 16.648438 L 14.347656 15.445312 C 14.421875 15.394531 14.472656 15.316406 14.472656 15.226562 L 14.472656 12.816406 C 14.472656 12.726562 14.421875 12.640625 14.347656 12.601562 L 12.257812 11.394531 C 12.214844 11.371094 12.171875 11.359375 12.132812 11.359375 C 12.089844 11.359375 12.046875 11.371094 12.003906 11.394531 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3773,
    y1: -0.0470335,
    x2: 0.9962,
    y2: -0.0470335,
    gradientTransform: "matrix(-4.86972,9.934194,-9.934194,-4.86972,15.009672,6.973476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(33.333333%,57.647059%,30.980392%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "rgb(35.294118%,67.843137%,27.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(35.294118%,67.843137%,27.058824%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.472656 11.050781 L 14.605469 11.050781 L 14.605469 16.972656 L 9.472656 16.972656 Z M 9.472656 11.050781 "
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.84375 15.378906 C 9.863281 15.402344 9.886719 15.425781 9.917969 15.445312 L 11.707031 16.476562 L 12.003906 16.648438 C 12.046875 16.675781 12.101562 16.683594 12.152344 16.679688 C 12.167969 16.679688 12.1875 16.675781 12.199219 16.667969 L 14.398438 12.640625 C 14.382812 12.625 14.363281 12.605469 14.339844 12.59375 L 12.972656 11.808594 L 12.253906 11.394531 C 12.234375 11.382812 12.210938 11.375 12.1875 11.371094 Z M 9.84375 15.378906 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0.050268,
    y1: 0.1331,
    x2: 0.6691,
    y2: 0.1331,
    gradientTransform: "matrix(8.86854,-6.552798,6.552798,8.86854,8.062902,15.201402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "rgb(38.039216%,59.607843%,34.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.27451%,67.45098%,39.215686%)",
      stopOpacity: 1
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.867188 11.050781 L 14.605469 11.050781 L 14.605469 16.972656 L 9.867188 16.972656 Z M 9.867188 11.050781 "
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.105469 11.359375 C 12.070312 11.363281 12.035156 11.371094 12.003906 11.386719 L 9.925781 12.589844 L 12.167969 16.675781 C 12.199219 16.667969 12.226562 16.664062 12.257812 16.644531 L 14.347656 15.4375 C 14.414062 15.402344 14.453125 15.335938 14.464844 15.265625 L 12.179688 11.363281 C 12.160156 11.359375 12.144531 11.359375 12.132812 11.359375 C 12.121094 11.359375 12.113281 11.359375 12.105469 11.359375 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1301,
    y1: 0.2836,
    x2: 0.7489,
    y2: 0.2836,
    gradientTransform: "matrix(7.334628,0,0,7.334628,8.972784,11.937774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41.960784%,74.901961%,27.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "rgb(41.960784%,74.901961%,27.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(47.45098%,70.588235%,38.039216%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(45.882353%,67.45098%,39.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(39.607843%,61.960784%,35.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 14.875 21.707031 C 14.800781 21.707031 14.730469 21.691406 14.664062 21.652344 L 14.003906 21.261719 C 13.910156 21.210938 13.957031 21.191406 13.984375 21.179688 C 14.117188 21.132812 14.144531 21.125 14.285156 21.042969 C 14.296875 21.035156 14.320312 21.035156 14.332031 21.046875 L 14.84375 21.347656 C 14.863281 21.359375 14.886719 21.359375 14.90625 21.347656 L 16.882812 20.207031 C 16.902344 20.195312 16.914062 20.179688 16.914062 20.15625 L 16.914062 17.875 C 16.914062 17.847656 16.902344 17.832031 16.882812 17.820312 L 14.910156 16.679688 C 14.890625 16.667969 14.867188 16.667969 14.851562 16.679688 L 12.875 17.820312 C 12.859375 17.832031 12.847656 17.847656 12.847656 17.875 L 12.847656 20.15625 C 12.847656 20.179688 12.859375 20.195312 12.875 20.207031 L 13.417969 20.519531 C 13.710938 20.667969 13.890625 20.496094 13.890625 20.320312 L 13.890625 18.0625 C 13.890625 18.03125 13.914062 18.003906 13.949219 18.003906 L 14.203125 18.003906 C 14.230469 18.003906 14.253906 18.03125 14.253906 18.0625 L 14.253906 20.316406 C 14.253906 20.707031 14.039062 20.933594 13.667969 20.933594 C 13.554688 20.933594 13.464844 20.933594 13.210938 20.808594 L 12.695312 20.507812 C 12.570312 20.433594 12.488281 20.296875 12.488281 20.148438 L 12.488281 17.867188 C 12.488281 17.71875 12.5625 17.578125 12.695312 17.507812 L 14.675781 16.367188 C 14.800781 16.296875 14.96875 16.296875 15.089844 16.367188 L 17.070312 17.507812 C 17.195312 17.578125 17.28125 17.71875 17.28125 17.867188 L 17.28125 20.148438 C 17.28125 20.296875 17.203125 20.433594 17.070312 20.507812 L 15.089844 21.648438 C 15.019531 21.683594 14.945312 21.707031 14.875 21.707031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 15.484375 20.136719 C 14.621094 20.136719 14.441406 19.738281 14.441406 19.402344 C 14.441406 19.375 14.464844 19.351562 14.5 19.351562 L 14.757812 19.351562 C 14.789062 19.351562 14.8125 19.367188 14.8125 19.398438 C 14.851562 19.65625 14.96875 19.789062 15.492188 19.789062 C 15.90625 19.789062 16.085938 19.691406 16.085938 19.46875 C 16.085938 19.34375 16.039062 19.25 15.390625 19.183594 C 14.851562 19.128906 14.515625 19.007812 14.515625 18.574219 C 14.515625 18.171875 14.851562 17.941406 15.414062 17.941406 C 16.050781 17.941406 16.363281 18.164062 16.398438 18.628906 C 16.398438 18.648438 16.390625 18.660156 16.378906 18.671875 C 16.367188 18.683594 16.355469 18.691406 16.339844 18.691406 L 16.078125 18.691406 C 16.054688 18.691406 16.03125 18.671875 16.023438 18.648438 C 15.964844 18.371094 15.816406 18.289062 15.410156 18.289062 C 14.953125 18.289062 14.898438 18.445312 14.898438 18.5625 C 14.898438 18.707031 14.957031 18.75 15.578125 18.832031 C 16.183594 18.910156 16.46875 19.027344 16.46875 19.457031 C 16.46875 19.890625 16.109375 20.136719 15.484375 20.136719 M 17.894531 17.71875 L 17.957031 17.71875 C 18.011719 17.71875 18.023438 17.679688 18.023438 17.660156 C 18.023438 17.597656 17.980469 17.597656 17.964844 17.597656 L 17.898438 17.597656 Z M 17.808594 17.527344 L 17.957031 17.527344 C 18.003906 17.527344 18.109375 17.527344 18.109375 17.640625 C 18.109375 17.71875 18.0625 17.734375 18.03125 17.742188 C 18.089844 17.746094 18.089844 17.785156 18.101562 17.839844 C 18.109375 17.875 18.113281 17.933594 18.125 17.953125 L 18.035156 17.953125 C 18.035156 17.933594 18.015625 17.828125 18.015625 17.820312 C 18.011719 17.796875 18.003906 17.785156 17.976562 17.785156 L 17.902344 17.785156 L 17.902344 17.957031 L 17.820312 17.957031 L 17.820312 17.527344 Z M 17.632812 17.742188 C 17.632812 17.921875 17.777344 18.0625 17.953125 18.0625 C 18.132812 18.0625 18.269531 17.914062 18.269531 17.742188 C 18.269531 17.5625 18.125 17.425781 17.953125 17.425781 C 17.777344 17.425781 17.632812 17.5625 17.632812 17.742188 M 18.335938 17.742188 C 18.335938 17.953125 18.164062 18.125 17.953125 18.125 C 17.742188 18.125 17.566406 17.957031 17.566406 17.742188 C 17.566406 17.527344 17.746094 17.359375 17.953125 17.359375 C 18.15625 17.363281 18.335938 17.527344 18.335938 17.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.098039%,25.490196%,21.568627%)",
      fillOpacity: 1
    },
    d: "M 8.746094 12.773438 C 8.746094 12.683594 8.699219 12.601562 8.621094 12.550781 L 6.527344 11.34375 C 6.492188 11.328125 6.449219 11.316406 6.414062 11.308594 L 6.390625 11.308594 C 6.347656 11.308594 6.3125 11.324219 6.277344 11.34375 L 4.183594 12.550781 C 4.105469 12.601562 4.054688 12.683594 4.054688 12.773438 L 4.0625 16.023438 C 4.0625 16.074219 4.085938 16.117188 4.121094 16.132812 C 4.160156 16.15625 4.210938 16.15625 4.25 16.132812 L 5.488281 15.417969 C 5.566406 15.371094 5.617188 15.289062 5.617188 15.199219 L 5.617188 13.679688 C 5.617188 13.589844 5.664062 13.507812 5.742188 13.457031 L 6.269531 13.152344 C 6.3125 13.128906 6.355469 13.117188 6.394531 13.117188 C 6.4375 13.117188 6.484375 13.128906 6.523438 13.152344 L 7.050781 13.457031 C 7.128906 13.507812 7.175781 13.585938 7.175781 13.679688 L 7.175781 15.199219 C 7.175781 15.289062 7.222656 15.371094 7.300781 15.417969 L 8.550781 16.132812 C 8.589844 16.15625 8.640625 16.15625 8.675781 16.132812 C 8.710938 16.109375 8.738281 16.070312 8.738281 16.023438 Z M 18.640625 14.464844 C 18.640625 14.488281 18.628906 14.507812 18.613281 14.519531 L 17.894531 14.933594 C 17.875 14.945312 17.847656 14.945312 17.828125 14.933594 L 17.105469 14.519531 C 17.085938 14.507812 17.074219 14.488281 17.074219 14.464844 L 17.074219 13.632812 C 17.074219 13.609375 17.085938 13.589844 17.105469 13.578125 L 17.828125 13.164062 C 17.84375 13.152344 17.867188 13.152344 17.894531 13.164062 L 18.613281 13.578125 C 18.628906 13.589844 18.640625 13.609375 18.640625 13.632812 Z M 18.839844 8.308594 C 18.796875 8.285156 18.75 8.285156 18.714844 8.308594 C 18.675781 8.335938 18.65625 8.375 18.65625 8.417969 L 18.65625 11.640625 C 18.65625 11.667969 18.636719 11.699219 18.613281 11.71875 C 18.582031 11.734375 18.550781 11.734375 18.523438 11.71875 L 17.996094 11.417969 C 17.914062 11.371094 17.820312 11.371094 17.742188 11.417969 L 15.640625 12.628906 C 15.5625 12.679688 15.515625 12.757812 15.515625 12.847656 L 15.515625 15.269531 C 15.515625 15.359375 15.5625 15.445312 15.640625 15.492188 L 17.742188 16.703125 C 17.820312 16.75 17.914062 16.75 17.996094 16.703125 L 20.09375 15.492188 C 20.171875 15.445312 20.21875 15.367188 20.21875 15.269531 L 20.21875 9.226562 C 20.21875 9.136719 20.171875 9.054688 20.089844 9.007812 Z M 25.824219 13.613281 C 25.902344 13.566406 25.949219 13.488281 25.949219 13.398438 L 25.949219 12.808594 C 25.949219 12.71875 25.902344 12.636719 25.824219 12.589844 L 23.742188 11.375 C 23.664062 11.328125 23.570312 11.328125 23.488281 11.375 L 21.390625 12.589844 C 21.3125 12.636719 21.261719 12.714844 21.261719 12.808594 L 21.261719 15.226562 C 21.261719 15.316406 21.3125 15.402344 21.390625 15.449219 L 23.472656 16.636719 C 23.550781 16.679688 23.640625 16.679688 23.71875 16.636719 L 24.976562 15.9375 C 25.019531 15.910156 25.042969 15.871094 25.042969 15.828125 C 25.042969 15.78125 25.019531 15.738281 24.976562 15.71875 L 22.867188 14.507812 C 22.824219 14.484375 22.800781 14.441406 22.800781 14.398438 L 22.800781 13.636719 C 22.800781 13.589844 22.824219 13.546875 22.867188 13.53125 L 23.519531 13.152344 C 23.5625 13.128906 23.609375 13.128906 23.644531 13.152344 L 24.300781 13.53125 C 24.34375 13.554688 24.367188 13.59375 24.367188 13.636719 L 24.367188 14.238281 C 24.367188 14.285156 24.390625 14.328125 24.433594 14.347656 C 24.472656 14.371094 24.523438 14.371094 24.558594 14.347656 Z M 25.824219 13.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 23.578125 13.5 C 23.589844 13.492188 23.617188 13.492188 23.628906 13.5 L 24.03125 13.734375 C 24.046875 13.742188 24.054688 13.757812 24.054688 13.777344 L 24.054688 14.238281 C 24.054688 14.253906 24.042969 14.273438 24.03125 14.28125 L 23.628906 14.515625 C 23.609375 14.519531 23.589844 14.519531 23.578125 14.515625 L 23.179688 14.28125 C 23.160156 14.273438 23.152344 14.253906 23.152344 14.238281 L 23.152344 13.777344 C 23.152344 13.757812 23.160156 13.742188 23.179688 13.734375 Z M 23.578125 13.5 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 16.578125 12.390625 L 10.699219 9.511719 L 7.6875 15.660156 L 13.566406 18.539062 Z M 16.578125 12.390625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 7.308594 13.242188 L 11.453125 18.859375 L 16.945312 14.808594 L 12.792969 9.183594 Z M 7.308594 13.242188 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 9.929688 11.359375 L 14.464844 11.359375 L 14.464844 16.675781 L 9.929688 16.675781 Z M 9.929688 11.359375 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.ffb9326554d40bd012ddac8038c897a6.svg";
export { ForwardRef as ReactComponent };